module.exports = __webpack_public_path__ + "id.d3091dea50591e57e821.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/id.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/id.svg
// module chunks = styles